import React from 'react';
import { Star, Sun, FileText, Heart, TrendingUp, User, AlertCircle, Moon } from 'lucide-react';
export const quickServices = [{
  id: 'natal',
  title: 'Натальная карта',
  desc: 'Глубокий анализ личности, талантов и жизненного пути',
  price: 'от 3 900 ₽',
  icon: <Star className="w-6 h-6" data-id="element-13666" />,
  accent: 'bg-indigo-50 text-indigo-600'
}, {
  id: 'solar',
  title: 'Соляр',
  desc: 'Прогноз на ваш личный год с точностью до месяца',
  price: 'от 4 400 ₽',
  icon: <Sun className="w-6 h-6" data-id="element-13667" />,
  accent: 'bg-amber-50 text-amber-600'
}, {
  id: 'combo',
  title: 'Комбо: Натал + Соляр',
  desc: 'Полная картина вашей жизни и прогноз на год со скидкой',
  price: 'от 6 900 ₽',
  icon: <FileText className="w-6 h-6" data-id="element-13668" />,
  accent: 'bg-slate-100 text-slate-600'
}, {
  id: 'compatibility',
  title: 'Совместимость',
  desc: 'Анализ отношений и кармических связей для пары',
  price: 'от 4 900 ₽',
  icon: <Heart className="w-6 h-6" data-id="element-13669" />,
  accent: 'bg-rose-50 text-rose-600'
}, {
  id: 'forecast',
  title: 'Прогноз',
  desc: 'Транзиты и ключевые периоды на ближайшие месяцы',
  price: 'от 3 900 ₽',
  icon: <TrendingUp className="w-6 h-6" data-id="element-13670" />,
  accent: 'bg-emerald-50 text-emerald-600'
}, {
  id: 'consultation',
  title: 'Консультация',
  desc: 'Живой разговор с астрологом по видеосвязи или в чате',
  price: 'от 2 990 ₽',
  icon: <User className="w-6 h-6" data-id="element-13671" />,
  accent: 'bg-violet-50 text-violet-600'
}];
export const topAstrologers = [{
  id: 1,
  name: 'Елена Смирнова',
  spec: 'Западная астрология',
  rating: 4.9,
  reviews: 124,
  color: 'bg-indigo-50 text-indigo-700'
}, {
  id: 2,
  name: 'Михаил Волков',
  spec: 'Ведическая астрология',
  rating: 5.0,
  reviews: 89,
  color: 'bg-emerald-50 text-emerald-700'
}, {
  id: 3,
  name: 'Анна Коваль',
  spec: 'Кармическая астрология',
  rating: 4.8,
  reviews: 210,
  color: 'bg-amber-50 text-amber-700'
}, {
  id: 4,
  name: 'Дмитрий Орлов',
  spec: 'Финансовая астрология',
  rating: 4.9,
  reviews: 156,
  color: 'bg-rose-50 text-rose-700'
}];
export const faqs = [{
  id: '1',
  title: 'Чем авто-отчёт отличается от консультации?',
  content: 'Авто-отчёт генерируется алгоритмом на основе точных астрономических данных и содержит подробное текстовое описание (до 40 страниц). Консультация с астрологом — это живой диалог, где специалист синтезирует информацию и отвечает на ваши конкретные вопросы.'
}, {
  id: '2',
  title: 'Нужно ли знать точное время рождения?',
  content: 'Да, для точного расчёта натальной карты желательно знать время рождения до минут. Если вы не знаете точного времени, наши астрологи могут провести процедуру ректификации.'
}, {
  id: '3',
  title: 'Как быстро я получу авто-отчёт?',
  content: 'Авто-отчёт формируется мгновенно после оплаты и ввода данных. PDF-файл будет доступен в вашем личном кабинете и отправлен на email.'
}, {
  id: '4',
  title: 'Что такое соляр?',
  content: 'Соляр — это астрологический прогноз на ваш личный год, который начинается в день вашего рождения и длится до следующего дня рождения.'
}, {
  id: '5',
  title: 'Можно ли заказать отчёт для другого человека?',
  content: 'Да! Вы можете заказать авто-отчёт или консультацию для друга, партнера или ребенка. Главное — знать их точные данные рождения.'
}, {
  id: '6',
  title: 'Какие способы оплаты вы принимаете?',
  content: 'Мы принимаем оплату банковскими картами (Visa, MasterCard, МИР) и через СБП. Все транзакции защищены SSL-шифрованием.'
}];
export const calendarEvents = [{
  id: 1,
  date: '14 Окт',
  type: 'Затмение',
  title: 'Солнечное затмение в Весах',
  desc: 'Время кармических изменений в партнерстве.',
  icon: <Sun className="w-5 h-5" data-id="element-13672" />,
  accent: 'bg-amber-50 text-amber-600 border-amber-200'
}, {
  id: 2,
  date: '28 Окт',
  type: 'Полнолуние',
  title: 'Лунное затмение в Тельце',
  desc: 'Завершение финансовых циклов.',
  icon: <Moon className="w-5 h-5" data-id="element-13673" />,
  accent: 'bg-indigo-50 text-indigo-600 border-indigo-200'
}, {
  id: 3,
  date: '13 Дек',
  type: 'Ретроград',
  title: 'Ретроградный Меркурий',
  desc: 'Задержки в делах, пересмотр планов.',
  icon: <AlertCircle className="w-5 h-5" data-id="element-13674" />,
  accent: 'bg-rose-50 text-rose-600 border-rose-200'
}];
export const blogArticles = [{
  id: 1,
  title: 'Как пережить ретроградный Меркурий без потерь',
  excerpt: 'Разбираем основные мифы и даем практические советы.',
  category: 'Прогнозы',
  date: '12 Окт 2024',
  readTime: '5 мин',
  gradient: 'from-indigo-100 to-slate-100'
}, {
  id: 2,
  title: 'Синастрия: почему мы выбираем "не тех"',
  excerpt: 'Астрологический взгляд на отношения и кармические связи.',
  category: 'Отношения',
  date: '10 Окт 2024',
  readTime: '8 мин',
  gradient: 'from-rose-100 to-slate-100'
}, {
  id: 3,
  title: 'Финансовый код в натальной карте',
  excerpt: 'Где спрятаны ваши деньги и как активировать потенциал.',
  category: 'Финансы',
  date: '08 Окт 2024',
  readTime: '6 мин',
  gradient: 'from-emerald-100 to-slate-100'
}];
export const reviews = [{
  id: 1,
  name: 'Мария В.',
  rating: 5,
  quote: 'Заказывала соляр на год. Отчёт пришел мгновенно, очень подробный и понятный. Многое уже начало сбываться!',
  date: '2 нед. назад'
}, {
  id: 2,
  name: 'Алексей С.',
  rating: 5,
  quote: 'Консультация с Еленой Смирновой помогла мне определиться с вектором развития бизнеса. Очень профессиональный подход.',
  date: '1 мес. назад'
}, {
  id: 3,
  name: 'Ольга К.',
  rating: 5,
  quote: 'Удобная платформа, всё в одном месте. Понравилась база трактовок — можно самому изучать свою карту.',
  date: '1 мес. назад'
}, {
  id: 4,
  name: 'Дмитрий П.',
  rating: 5,
  quote: 'Скептически относился к астрологии, но натальная карта удивила точностью описания характера. Рекомендую попробовать.',
  date: '2 мес. назад'
}, {
  id: 5,
  name: 'Екатерина Л.',
  rating: 5,
  quote: 'Заказала совместимость для нас с мужем — многое стало понятнее в наших отношениях. Теперь знаем, над чем работать.',
  date: '2 мес. назад'
}, {
  id: 6,
  name: 'Игорь М.',
  rating: 4,
  quote: 'Отчёт по натальной карте очень детальный, 35 страниц! Единственное — хотелось бы больше практических советов.',
  date: '3 мес. назад'
}, {
  id: 7,
  name: 'Анна Р.',
  rating: 5,
  quote: 'Подарила маме натальную карту на день рождения — она была в восторге! Очень удобно, что можно заказать для другого человека.',
  date: '3 мес. назад'
}, {
  id: 8,
  name: 'Светлана Т.',
  rating: 5,
  quote: 'Пользуюсь подпиской уже полгода. Каждый месяц получаю отчёт и слежу за транзитами. Очень помогает в планировании.',
  date: '4 мес. назад'
}, {
  id: 9,
  name: 'Виктор Н.',
  rating: 5,
  quote: 'Консультация по финансовой астрологии с Дмитрием Орловым — лучшая инвестиция. Чётко показал удачные периоды для сделок.',
  date: '4 мес. назад'
}, {
  id: 10,
  name: 'Наталья Б.',
  rating: 5,
  quote: 'Комбо натал + соляр — идеальный вариант. Получила полную картину и прогноз на год. Всё структурировано и понятно.',
  date: '5 мес. назад'
}];
export const ratingBreakdown = [{
  stars: 5,
  percent: 89
}, {
  stars: 4,
  percent: 8
}, {
  stars: 3,
  percent: 2
}, {
  stars: 2,
  percent: 0
}, {
  stars: 1,
  percent: 1
}];
export const pricingCards = [{
  title: 'Натальная карта',
  desc: 'Полный анализ личности, характера и потенциала',
  features: ['Анализ личности и характера', 'Таланты и предназначение', 'Рекомендации'],
  price: '3 900 ₽',
  oldPrice: null as string | null,
  popular: false,
  route: 'service-natal'
}, {
  title: 'Соляр',
  desc: 'Астрологический прогноз на ваш личный год',
  features: ['Главная тема года', 'Ключевые сферы и периоды', 'Рекомендации'],
  price: '4 400 ₽',
  oldPrice: null as string | null,
  popular: false,
  route: 'service-solar'
}, {
  title: 'Комбо: Натал + Соляр',
  desc: 'Полный анализ личности и прогноз на год',
  features: ['Полная натальная карта', 'Полный соляр', 'Рекомендации'],
  price: '6 900 ₽',
  oldPrice: '8 300 ₽',
  popular: true,
  route: 'service-combo'
}, {
  title: 'Совместимость',
  desc: 'Синастрия для пар и партнёров',
  features: ['Эмоциональная связь', 'Зоны конфликтов', 'Кармические связи'],
  price: '4 900 ₽',
  oldPrice: null as string | null,
  popular: false,
  route: 'service-compatibility'
}, {
  title: 'Прогноз (Транзиты)',
  desc: 'Прогноз на ближайшие месяцы',
  features: ['Полный анализ транзитов', 'Ключевые даты', 'Рекомендации'],
  price: '3 900 ₽',
  oldPrice: null as string | null,
  popular: false,
  route: 'service-forecast'
}];
export const cardAccents = [{
  icon: <Star className="w-5 h-5 text-indigo-600" data-id="element-13675" />,
  iconBg: 'bg-indigo-100',
  border: 'border-t-indigo-400',
  checkBg: 'bg-indigo-100',
  checkText: 'text-indigo-600',
  tint: 'from-indigo-50/40'
}, {
  icon: <Sun className="w-5 h-5 text-amber-600" data-id="element-13676" />,
  iconBg: 'bg-amber-100',
  border: 'border-t-amber-400',
  checkBg: 'bg-amber-100',
  checkText: 'text-amber-600',
  tint: 'from-amber-50/40'
}, {
  icon: <FileText className="w-5 h-5 text-white" data-id="element-13677" />,
  iconBg: 'bg-white/20',
  border: '',
  checkBg: 'bg-white/20',
  checkText: 'text-white',
  tint: ''
}, {
  icon: <Heart className="w-5 h-5 text-rose-600" data-id="element-13678" />,
  iconBg: 'bg-rose-100',
  border: 'border-t-rose-400',
  checkBg: 'bg-rose-100',
  checkText: 'text-rose-600',
  tint: 'from-rose-50/40'
}, {
  icon: <TrendingUp className="w-5 h-5 text-emerald-600" data-id="element-13679" />,
  iconBg: 'bg-emerald-100',
  border: 'border-t-emerald-400',
  checkBg: 'bg-emerald-100',
  checkText: 'text-emerald-600',
  tint: 'from-emerald-50/40'
}];
export const packagesData = [{
  title: 'Пакет 20 отчётов',
  desc: 'Идеально для первого знакомства с астрологией',
  features: ['Любые 20 Premium-отчётов', 'Натальная карта, Соляр, Совместимость'],
  price: '19 900 ₽',
  perUnit: '≈ 995 ₽ за отчёт',
  perUnitColor: 'text-indigo-600',
  popular: false,
  savings: null as string | null
}, {
  title: 'Пакет 50 отчётов',
  desc: 'Оптимальный выбор для анализа себя и близких',
  features: ['Любые 50 Premium-отчётов', 'Для себя и партнёра'],
  price: '44 900 ₽',
  perUnit: '≈ 898 ₽ за отчёт',
  perUnitColor: 'text-violet-600',
  popular: true,
  savings: 'Экономия 10%'
}, {
  title: 'Пакет 100 отчётов',
  desc: 'Максимальная выгода для глубокого изучения',
  features: ['Любые 100 Premium-отчётов', 'Подарки друзьям и близким'],
  price: '79 900 ₽',
  perUnit: '≈ 799 ₽ за отчёт',
  perUnitColor: 'text-emerald-600',
  popular: false,
  savings: 'Экономия 20%'
}];